if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section =
          document.getElementById('MainProduct-' + this.sectionId) ||
          document.querySelector('[data-section="' + this.sectionId + '"]');

        this.productForm = this.section && this.section.querySelector('product-form');
        this.realButton = this.productForm && this.productForm.querySelector('[name="add"]');

        this.stickyButton = this.querySelector('.sticky-atc__button');
        this.stickyLabel = this.querySelector('.sticky-atc__button-label');
        this.stickyPrice = this.querySelector('.sticky-atc__price');
        this.stickySpinner = this.querySelector('.loading__spinner');
        this.stickyImage = this.querySelector('.sticky-atc__image');
        this.defaultImageSrc = this.stickyImage && this.stickyImage.getAttribute('src');

        this.mainPrice = document.getElementById('price-' + this.sectionId);
        this.mainLabel = this.section && this.section.querySelector('.product-form__submit-label');
        this.variantSource =
          this.section && this.section.querySelector('variant-radios, variant-selects');

        this.skioPicker = this.section && this.section.querySelector('[skio-plan-picker]');

        if (!this.realButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', this.onClick.bind(this));

        this.setupVisibility();
        this.setupSync();
      }

      onClick(event) {
        event.preventDefault();
        if (this.stickyButton.getAttribute('aria-disabled') === 'true') return;
        this.realButton.click();
      }

      setupVisibility() {
        this.anchor = this.productForm.querySelector('.product-form__buttons') || this.realButton;
        this.footer = document.querySelector('.footer') || document.querySelector('footer');

        if (!('IntersectionObserver' in window) || !this.anchor) {
          this.classList.add('is-visible');
          document.body.classList.add('sticky-atc-active');
          return;
        }

        this.anchorVisible = true;
        this.footerVisible = false;

        this.anchorObserver = new IntersectionObserver(
          (entries) => {
            this.anchorVisible = entries[entries.length - 1].isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0 }
        );
        this.anchorObserver.observe(this.anchor);

        if (this.footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.footerVisible = entries[entries.length - 1].isIntersecting;
              this.updateVisibility();
            },
            { threshold: 0 }
          );
          this.footerObserver.observe(this.footer);
        }
      }

      updateVisibility() {
        const show = !this.anchorVisible && !this.footerVisible;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('sticky-atc-active', show);
      }

      setupSync() {
        const update = this.syncState.bind(this);
        update();

        this.observer = new MutationObserver(update);

        if (this.mainPrice) {
          this.observer.observe(this.mainPrice, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
        if (this.mainLabel) {
          this.observer.observe(this.mainLabel, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
        this.observer.observe(this.realButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });

        if (this.skioPicker) {
          this.syncSkioPrice();
          this.skioPicker.addEventListener('change', () => this.syncSkioPrice());
          this.skioPicker.addEventListener('skio:plan-picker:update', () =>
            this.syncSkioPrice()
          );
          this.skioObserver = new MutationObserver(() => this.syncSkioPrice());
          this.skioObserver.observe(this.skioPicker, {
            subtree: true,
            childList: true,
            characterData: true,
          });
        }
      }

      syncState() {
        if (!this.skioPicker && this.mainPrice && this.stickyPrice) {
          this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
        }
        if (this.mainLabel && this.stickyLabel) {
          this.stickyLabel.textContent = this.mainLabel.textContent.trim();
        }

        const disabled =
          this.realButton.disabled ||
          this.realButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.toggleAttribute('disabled', disabled);
        this.stickyButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');

        this.updateImage();
      }

      syncSkioPrice() {
        if (!this.skioPicker || !this.stickyPrice) return;
        const checked = this.skioPicker.querySelector('.skio-group-input:checked');
        if (!checked) return;
        const scope =
          (checked.id && this.skioPicker.querySelector('label[for="' + checked.id + '"]')) ||
          checked.closest('.skio-group-container, .skio-subscription-wrapper') ||
          checked.parentNode;
        if (!scope) return;
        const priceEl = scope.querySelector('[skio-subscription-price], [skio-onetime-price]');
        const price = priceEl && priceEl.textContent.trim();
        if (price) this.stickyPrice.textContent = price;
      }

      updateImage() {
        if (!this.stickyImage || !this.variantSource) return;
        const variant = this.variantSource.currentVariant;
        if (!variant) return;
        const image =
          variant.featured_image ||
          (variant.featured_media && variant.featured_media.preview_image);
        const src = image && image.src ? this.sizedSrc(image.src) : this.defaultImageSrc;
        if (src && this.stickyImage.getAttribute('src') !== src) {
          this.stickyImage.src = src;
          if (image && image.alt) this.stickyImage.alt = image.alt;
        }
      }

      sizedSrc(src) {
        if (/[?&]width=/.test(src)) return src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      }
    }
  );
}
